export default "__VITE_ASSET__DuDFScmA__"